// BodyTypeCalculator.js
import React, { lazy, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import bodyMeasureOutline from "../../../images/body-measure.webp";
const TITLE = "Kalkulator Penentuan Bentuk Tubuh - Ketahui Bentuk Tubuh Anda";
const DESCRIPTION =
  "Kalkulator bentuk tubuh membantu Anda menentukan bentuk tubuh Anda berdasarkan ukuran dada, pinggang, paha, dan pinggul. Ini dapat memberi Anda wawasan tentang bentuk tubuh Anda.";
const KEYWORDS =
  "kalkulator bentuk tubuh, bentuk tubuh, ukuran dada, ukuran pinggang, ukuran pinggul, ukuran paha";
const OG_URL = "https://do-calculate.com/calculator/id/body-type-calculator/";
function BodyTypeCalculator() {
  const [bust, setBust] = useState("");
  const [waist, setWaist] = useState("");
  const [highHip, setHighHip] = useState("");
  const [hip, setHip] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [whr, setWHR] = useState(null);
  const handleBustChange = (event) => {
    setBust(event.target.value);
  };
  const handleWaistChange = (event) => {
    setWaist(event.target.value);
  };
  const handleHighHipChange = (event) => {
    setHighHip(event.target.value);
  };
  const handleHipChange = (event) => {
    setHip(event.target.value);
  };
  const calculateBodyType = () => {
    const bustNum = parseFloat(bust);
    const waistNum = parseFloat(waist);
    const highHipNum = parseFloat(highHip);
    const hipNum = parseFloat(hip);
    if (
      isNaN(bustNum) ||
      isNaN(waistNum) ||
      isNaN(highHipNum) ||
      isNaN(hipNum) ||
      bustNum <= 0 ||
      waistNum <= 0 ||
      highHipNum <= 0 ||
      hipNum <= 0
    ) {
      setError("Masukkan nilai yang valid");
      setResult(null);
      setWHR(null);
      return;
    }
    let bodyType = "Tidak diketahui";
    const whrValue = (waistNum / hipNum).toFixed(2);
    if (bustNum === hipNum && waistNum < bustNum) {
      bodyType = "Jam Pasir";
    } else if (hipNum > bustNum && waistNum < hipNum) {
      bodyType = "Pir";
    } else if (bustNum > hipNum && waistNum < bustNum) {
      bodyType = "Segitiga Terbalik";
    } else if (bustNum === waistNum && waistNum === hipNum) {
      bodyType = "Persegi Panjang";
    } else if (waistNum >= bustNum && waistNum >= hipNum) {
      bodyType = "Apel";
    }
    setResult(bodyType);
    setWHR(whrValue);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-7">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator bentuk tubuh membantu Anda menentukan bentuk tubuh Anda berdasarkan ukuran dada, pinggang, pinggul, dan paha. Dengan kalkulator ini, Anda bisa mendapatkan pemahaman yang akurat tentang bentuk tubuh Anda, membantu Anda memilih pakaian yang paling sesuai. Mengetahui bentuk tubuh Anda tidak hanya berkontribusi pada peningkatan penampilan Anda, tetapi juga meningkatkan kepercayaan diri dan kenyamanan Anda dalam kehidupan sehari-hari. Dengan menggunakan kalkulator, Anda dapat menentukan area yang ingin Anda tonjolkan dan area yang ingin Anda minimalkan, membantu Anda memilih pakaian yang meningkatkan penampilan Anda secara keseluruhan dan sesuai dengan gaya pribadi Anda. Baik Anda bertujuan untuk menonjolkan kecantikan alami Anda atau mencapai keseimbangan antara berbagai detail tubuh Anda, kalkulator ini adalah alat yang sempurna untuk mencapai hal itu.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-8 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Bentuk Tubuh
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="bust" className="form-label ms-2">
                      Ukuran Dada
                    </label>
                  </b>
                  <input
                    type="number"
                    id="bust"
                    value={bust}
                    onChange={handleBustChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="waist" className="form-label ms-2">
                      Ukuran Pinggang
                    </label>
                  </b>
                  <input
                    type="number"
                    id="waist"
                    value={waist}
                    onChange={handleWaistChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="highHip" className="form-label ms-2">
                      Ukuran Paha
                    </label>
                  </b>
                  <input
                    type="number"
                    id="highHip"
                    value={highHip}
                    onChange={handleHighHipChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="hip" className="form-label ms-2">
                      Ukuran Pinggul
                    </label>
                  </b>
                  <input
                    type="number"
                    id="hip"
                    value={hip}
                    onChange={handleHipChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBodyType}
                  >
                    Hitung
                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <img
                  loading="lazy"
                  src={bodyMeasureOutline}
                  alt="Ilustrasi pengukuran"
                  style={{ width: "100%", paddingTop: "100px", height: "60%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div>
                  {error && (
                    <div
                      style={{
                        backgroundColor: "#f8d7da",
                        borderColor: "#f5c6cb",
                        color: "#721c24",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <b>
                        <u>Error:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <h4>Hasil:</h4>
                      <p
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        Bentuk tubuh Anda adalah: {result}
                      </p>
                      <p>Rasio Pinggang ke Pinggul (WHR): {whr}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Cara Menggunakan Kalkulator Bentuk Tubuh?
              </div>
              <div className="info-section-body">
                <p>
                  Untuk menggunakan kalkulator bentuk tubuh, masukkan ukuran dada, pinggang, pinggul, dan paha. Kemudian, klik tombol "Hitung" untuk mendapatkan bentuk tubuh Anda. Pastikan untuk mengukur dengan benar untuk mendapatkan hasil yang akurat.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      Bagaimana Cara Mengukur Tubuh Anda dengan Benar?
                    </div>
                    <div className="info-section-body">
                      <p>
                        Saat mengukur, berdiri tegak dengan lengan rileks di samping. Pastikan pita pengukur menyentuh tubuh tanpa menekan terlalu keras pada kulit, karena dapat menyebabkan hasil yang tidak akurat.
                      </p>
                      <ul>
                        <li>
                          <strong>Ukuran Dada</strong>: Ukur lingkar dada di sekitar bagian terpenuh, kenakan bra yang sesuai.
                        </li>
                        <li>
                          <strong>Ukuran Pinggang</strong>: Ukur lingkar terkecil di sekitar pinggang alami, sedikit di atas pusar.
                        </li>
                        <li>
                          <strong>Ukuran Paha Atas</strong>: Ukur lingkar bagian atas paha, sekitar 7 inci (18 cm) di bawah pinggang alami.
                        </li>
                        <li>
                          <strong>Ukuran Pinggul</strong>: Ukur lingkar di sekitar bagian terpenuh dari pinggul dan bokong.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      Bentuk Tubuh Wanita dalam Industri Fashion
                    </div>
                    <div className="info-section-body">
                      <p>
                        Dalam industri fashion, bentuk tubuh wanita biasanya diklasifikasikan ke dalam empat kategori:
                      </p>
                      <ul>
                        <li>
                          <strong>Apel (Segitiga Terbalik)</strong>: Ditandai dengan bahu dan dada yang lebih lebar dari pinggul.
                        </li>
                        <li>
                          <strong>Pisang (Lurus atau Persegi Panjang)</strong>: Ditandai dengan ukuran pinggang yang kurang dari 9 inci dari ukuran dada atau pinggul.
                        </li>
                        <li>
                          <strong>Pir (Sendok, Lonceng, Segitiga)</strong>: Ditandai dengan ukuran pinggul yang lebih besar dari ukuran dada.
                        </li>
                        <li>
                          <strong>Jam Pasir (Bentuk X, Segitiga Berlawanan)</strong>
                          : Ditandai dengan ukuran dada dan pinggul yang hampir sama, dengan pinggang yang sempit.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BodyTypeCalculator;